import { useNavigate } from 'react-router-dom';
import { STORE } from 'state/store/type';
import URL from 'utils/url';
import { oneAppUrl } from 'utils/urlGenerator';
import { ENV } from 'utils/config';
import { ORG_LEVEL_PARAM } from 'utils/constants';
import accessLocalStorage from 'services/localStorage';
import { isDashboardInNativeMode } from 'utils/dashboard';

export const useStoreNavigation = () => {
  const navigate = useNavigate();

  const navigateToDashboard = (orgId: string, isOrgLevel = true) => {
    const search = `${ORG_LEVEL_PARAM.KEY}=${isOrgLevel}`;

    if (isDashboardInNativeMode()) {
      URL.openInNewTab(`${window.location.origin}/${orgId}?${search}`);
      return;
    }

    accessLocalStorage.setIsOrgLevel(isOrgLevel);
    navigate(`/${orgId}?${search}`);
  };

  const handleStoreClick = (
    store: STORE.IStore,
    hasAccess: boolean,
    onNoAccess: () => void
  ) => {
    if (!hasAccess) {
      onNoAccess();
      return;
    }
    navigateToDashboard(store.organization_id, false);
  };

  const handleOrgViewClick = (orgId: string) => {
    navigateToDashboard(orgId, true);
  };

  const handleAddStoreClick = () => {
    URL.openInNewTab(oneAppUrl(ENV));
  };

  return {
    navigateToDashboard,
    handleStoreClick,
    handleOrgViewClick,
    handleAddStoreClick,
  };
};
